// @flow

import Button from './button';
import { default as ButtonRedTemplate } from './templates/red.html';
import { default as ButtonGoldTemplate } from './templates/gold.html';
import { default as ButtonSuitcaseTemplate } from './templates/suitcase.html';

export const COMPONENTS_BTN_GOLD_NAME = 'btn-gold';
export const COMPONENTS_BTN_RED_NAME = 'btn-red';
export const COMPONENTS_BTN_SUITCASE_NAME = 'btn-suitcase';

export const COMPONENTS_BTN_ENTITIES = [
	{
		name: COMPONENTS_BTN_GOLD_NAME,
		entity: Button,
		template: ButtonGoldTemplate,
	},
	{
		name: COMPONENTS_BTN_RED_NAME,
		entity: Button,
		template: ButtonRedTemplate,
	},
	{
		name: COMPONENTS_BTN_SUITCASE_NAME,
		entity: Button,
		template: ButtonSuitcaseTemplate,
	},
];
